// ------
// Keep Screen On
// ------

let wakeLock;

async function requestWakeLock() {
  try {
    wakeLock = await navigator.wakeLock.request('screen');

    // eslint-disable-next-line no-console
    console.log('Wake Lock active:', !!wakeLock);
  } catch (err) {
    console.error(`${err.name}, ${err.message}`);
  }
}

attachEvent('[data-keep-screen-on]', 'click', (wakeButton) => {
  if ('wakeLock' in navigator) {
    requestWakeLock();
    wakeButton.disabled = true;
  }
});
